import { Box, CardMedia, Typography } from '@mui/material';
import lemonBackground from '@/views/images/background.png';
import lemonTapIcon from '@/views/images/lemontap-icon.png';
import { Build } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * Maintenance screen displayed during scheduled maintenance.
 * Shows a simple message letting users know that maintenance is in progress
 * and that sharing digital business cards still works.
 */
const MaintenanceScreen = () => {
  const { i18n } = useTranslation();
  const isGerman = i18n.language?.startsWith('de');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        background: `url(${lemonBackground}) no-repeat`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 3,
          p: 4,
          maxWidth: 500,
        }}
      >
        <CardMedia component={'img'} src={lemonTapIcon} sx={{ width: '5rem' }} />

        <Build sx={{ fontSize: 64, color: 'primary.contrastText' }} />

        <Typography variant='h4' color='primary.contrastText' fontWeight='bold'>
          {isGerman ? 'Wartungsarbeiten' : 'Scheduled Maintenance'}
        </Typography>

        <Typography variant='body1' color='primary.contrastText'>
          {isGerman
            ? 'Wir führen derzeit geplante Wartungsarbeiten durch. Bitte versuche es später erneut.'
            : 'We are currently performing scheduled maintenance. Please check back later.'}
        </Typography>

        <Typography variant='body2' color='primary.contrastText' sx={{ opacity: 0.8, mt: 2 }}>
          {isGerman
            ? '💡 Das Teilen deiner digitalen Visitenkarte funktioniert weiterhin!'
            : '💡 Sharing your digital business card still works!'}
        </Typography>

        <Typography variant='body2' color='primary.contrastText' sx={{ opacity: 0.8, mt: 3 }}>
          {isGerman
            ? 'Wenn du dennoch Probleme beim Teilen der Visitenkarte hast, dann schreibe uns eine E-Mail an support@lemontaps.com.'
            : 'If you do have difficulties sharing your business card, contact us via E-Mail at support@lemontaps.com.'}
        </Typography>
      </Box>
    </Box>
  );
};

export default MaintenanceScreen;
